import {
  CountryCode,
  isValidPhoneNumber as isValidPhoneNumberFns,
} from 'libphonenumber-js';

export function isValidPhoneNumber(
  text: string,
  defaultCountry?: string,
): boolean {
  return isValidPhoneNumberFns(text, defaultCountry as CountryCode);
}
